import { useCallback, useRef } from 'react';
import {atom, useRecoilState} from 'recoil';
import { getHistory, History } from '../../Data/Purchase/History';

const HistoryObject = atom<History>({
    key: "HistoryObject",
    default: [],
    dangerouslyAllowMutability: true,
});

export const useHistorys = () => {
    const [history, setHistory] = useRecoilState(HistoryObject);

    const isRefreshing = useRef(false);

    const fetch = useCallback(async () => {
        const newHistory: History | null = await getHistory();

        if (!newHistory) {
            return;
        }

        setHistory(newHistory);
    }, [setHistory]);

    const secureFetch = useCallback(()=>{
        if (isRefreshing.current || history.length > 0){
            return;
        }
        fetch();
    }, [fetch, history.length]);

    const refresh = useCallback(async () => {
        if (isRefreshing.current){
            return;
        }
        isRefreshing.current = true;
        await fetch();
        isRefreshing.current = false;
    },[fetch]);

    return {fetch: secureFetch, refresh, history};
}